import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import {
    loadContractDetailsForContractId,
    loadServiceDetailsForContractId
} from '../../../store/directusService';
import { setCurrentlySelectedParticipant } from '../../../store/participantService';
import StaticField from '../../formElements/StaticField';

const StaticParticipant = ({ participant = {}, hasParticipantAccess = true, onNav }) => {
    // HOOKs
    const navigate = useNavigate();
    const dispatch = useDispatch();

    // LOCAL STATE
    const [isPTRequestSent, setIsPTRequestSent] = useState(false);

    // STORE STATE
    const currentParticipant = useSelector(
        (state) => state.entities.participantService.currentParticipant
    );
    const contractDetailsById = useSelector(
        (state) => state.entities.directusService.contractDetailsById
    );
    const servicesByContractId = useSelector(
        (state) => state.entities.directusService.servicesByContractId
    );

    // USEEFFECTS
    useEffect(() => {
        if((!participant || !participant.firstName)) return;
        if (isPTRequestSent && currentParticipant?.ptCode === participant.ptCode) {
            if (!(currentParticipant.contractId in contractDetailsById))
                dispatch(loadContractDetailsForContractId(currentParticipant.contractId));
            if (!(currentParticipant.contractId in servicesByContractId))
                dispatch(loadServiceDetailsForContractId(currentParticipant.contractId));
        }
    }, [currentParticipant, isPTRequestSent]);

    useEffect(() => {
        if((!participant || !participant.firstName)) return;
        if (
            isPTRequestSent &&
            currentParticipant?.ptCode === participant.ptCode &&
            contractDetailsById[currentParticipant.contractId] &&
            servicesByContractId[currentParticipant.contractId]
        ) {
            onNav();
            navigate('/edit_participant');
        }
    }, [isPTRequestSent, contractDetailsById, servicesByContractId, currentParticipant]);

    // EVENT HANDLERS
    const onClickPTCode = () => {
        if((!participant || !participant.id)) return;
        if (participant.id !== currentParticipant?.id)
            dispatch(setCurrentlySelectedParticipant(participant));
        setIsPTRequestSent(true);
    };

    //RENDER
    return participant && participant.firstName ? (
        <StaticField
            id={'participantName'}
            label="Participant"
            link={hasParticipantAccess ? `${participant?.firstName} ${participant?.lastName}` : ''}
            content={!hasParticipantAccess ? `${participant?.firstName} ${participant?.lastName}` : ''}
            onClick={onClickPTCode}
        />
    ) : (
        <StaticField
            id={'participantName'}
            label="Participant"
            content={participant?.noMatchingService
                ? "You do not currently share a service with the participant for this appointment."
                : "No participant is attached to this appointment"
        }
        />
    );
};

StaticParticipant.propTypes = {
    participant: PropTypes.object,
    hasParticipantAccess: PropTypes.bool,
    onNav: PropTypes.func
};

export default StaticParticipant;
